<template>
  <div>
    <div class="banner-wrap">
      <Banner class="pc-banner" :is-hitech="false" />
    </div>
    <div class="section_inner">
      <ArticleBreadcrumbs :items="breadCrumbs" class="pr-0 pr-md-3" />
      <h1 class="display-36 primary--text font-weight-normal px-2">מפת אתר</h1>

      <v-row class="px-2">
        <v-col v-for="(cat, i) in categories" :key="i" cols="12" md="4" xs="3">
        <p class="display-20 pb-1 secondary2--text">  
          <nuxt-link class="cat-title underline" :to="`/jobs/cat${cat.id}/`" :title="` ${cat.name}`">
            דרושים 
            {{ cat.name.replace(' / ','/')  }}    
          </nuxt-link>
        </p>
       
          <v-row>
            <v-col class="pt-0">
              <ul class="list-style-none areas">
                <li v-for="(area, i) in areasToDisplay" :key="i">
                  <nuxt-link
                    target="_self"
                    :title=" `דרושים ${ cat.name.replace(' / ','/') } ב${ area.name } `"
                    class="display-16 "
                    :to="`/jobs/cat${cat.id}/area/${area.area}/?geolexid=${area.geolex}&amp;range=3&amp;ssaen=1`"
                  >
                    דרושים
                    {{ cat.name.replace(' / ','/') }}
                    ב{{ area.name }}
                </nuxt-link>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
  
  
<script>
import Banner from '@/components/Jobs_List/Banner';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { SUB_CATEGORIES } from '@/lib/api.js';

export default {
  layout: 'categories',
  name: 'sitemapPage',
  mixins: [SeoOptimization],
  components: {
    Banner
  },

  data() {
    return {
      categories: {},
      areasToDisplay: {
        18: {
          area: 18,
          geolex: 537511,
          name: 'ירושלים'
        },
        2: {
          area: 15,
          geolex: 539073,
          name: 'אשדוד'
        },
        3: {
          area: 5,
          geolex: 539128,
          name: 'פתח תיקווה'
        },
        4: {
          area: 4,
          geolex: 539078,
          name: 'ראשון לציון'
        },
        5: {
          area: 10,
          geolex: 539080,
          name: 'נתניה'
        },
        6: {
          area: 30,
          geolex: 539077,
          name: 'באר שבע'
        },
        7: {
          area: 21,
          geolex: 539095,
          name: 'חיפה'
        },
        8: {
          area: 1,
          geolex: 537905,
          name: 'תל אביב'
        }
      },
      breadCrumbs: []
    };
  },

  async asyncData(context) {
    try {
      const {
        data: { data }
      } = await context.$axios.get(SUB_CATEGORIES);

      if (!data) {
        throw 'שגיאת מערכת ';
      }

      return {
        categories: data,
        breadCrumbs: [
          {
            name: 'home',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'sitemap',
            value: 'מפת אתר',
            link: '/sitemap/'
          }
        ]
      };
    } catch (e) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'all categories page error '
      });
    }
  },
  head() {
    return {
      link: [
        {
          //canonical doesnt returned from api
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: 'דרושים IL - מפת אתר'
    };
  }
};
</script>
  
  
<style lang="scss" scoped>
.areas a,
.cat-title {
  color: #2e2824;
}
.areas a:hover,
.cat-title:hover {
  color: $primary;
}
</style>
